import React from 'react'
import ExportEventMenuItemBase from './ExportEventMenuItemBase'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {useGet} from 'lib/requests'

const ExportAttendeeZoomLogDetailedMenuItem = React.forwardRef<
  HTMLLIElement,
  {
    setError: (error: string | null) => void
    setSuccess: (success: string | null) => void
  }
>((props, ref) => {
  const {exportLog, processing, errorMessage, successMessage} = useExportLog(
    false,
  )

  return (
    <ExportEventMenuItemBase
      ref={ref}
      label="Export Detail Log"
      ariaLabel="export event detail log"
      onExport={exportLog}
      processing={processing}
      errorMessage={errorMessage}
      successMessage={successMessage}
      setError={props.setError}
      setSuccess={props.setSuccess}
    />
  )
})

ExportAttendeeZoomLogDetailedMenuItem.displayName =
  'ExportAttendeeZoomLogDetailedMenuItem'

export default ExportAttendeeZoomLogDetailedMenuItem

function useExportLog(isSummary?: boolean) {
  const {event} = useEvent()
  const exportMode = isSummary ? 'summary' : 'detail'
  const url = api(
    `/events/${event.id}/attendee_zoom_logs/export?exportMode=${exportMode}`,
  )
  const {client} = useOrganization()

  const {send: exportLog, processing, errorMessage, successMessage} = useGet(
    client,
    url,
  )

  return {
    exportLog,
    processing,
    errorMessage,
    successMessage,
  }
}
